import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  DKLabel,
  DKButton,
  DKInput,
  INPUT_TYPE,
  INPUT_VIEW_DIRECTION,
  DKContactIcon,
  DKIcon,
  DKIcons,
  showAlert,
  DKListPicker,
} from "deskera-ui-library";
import { connect, ConnectedProps } from "react-redux";
// import { getFullName } from "../../model/User";
// import { Team } from "../../services/team";
// import { store } from "../../redux/store";
// import { fetchTeams } from "../../redux/slices/tenantSlice";
import InviteUser from "./InviteUser";
import { PERMISSIONS } from "../../constants/Permission";
import { INVITE_USER_STATUS } from "../../constants/Permission";
// import { IPermissionPayload } from "../../model/PermissionModel";

export interface IAddTeamPopupProps extends PropsFromRedux {
  recordId?: any;
  onClose?: () => void;
  selectedTeam?: any;
  onTeamCreate?: (data: any) => void;
}

export interface IAddTeamPopupState {
  users?: any;
  canValidate: boolean;
  name?: string;
  userIds?: any;
  permission?: any;
  needPermissionPicker?: boolean;
}

class AddTeamPopup extends Component<IAddTeamPopupProps, IAddTeamPopupState> {
  constructor(props) {
    super(props);
    this.state = {
      canValidate: false,
      name: this.props.selectedTeam ? this.props.selectedTeam.name : "",
      userIds:
        this.props.selectedTeam && this.props.selectedTeam.userIds
          ? this.props.selectedTeam.userIds
          : [],
      permission: PERMISSIONS[3],
      needPermissionPicker: false,
    };
  }
  componentDidMount() {}
  render() {
    return (
      <div className=" transparent-background-light">
        <div
          className="p-h-r pt-r pb-xl popup-window"
          style={{ overflow: "visible" }}
        >
          {this.getHeader()}
          {this.getInputField()}
          {this.getUsersSection()}
          {/* {this.getInviteUserSection()} */}
        </div>
      </div>
    );
  }
  getHeader() {
    return (
      <div className="row justify-content-between">
        <DKLabel
          text={this.props.selectedTeam._id ? "Edit Team" : "New Team"}
          className="fw-b fs-m"
        />
        <div className="row width-auto">
          <DKButton
            title="Cancel"
            className="bg-gray1 border-m"
            onClick={() => {
              this.removePopUp();
            }}
          />
          <DKButton
            title="Save"
            className="bg-button text-white ml-r"
            onClick={() => {
              this.setState({
                canValidate: true,
              });
              if (this.validateName()) {
                this.onSubmit();
              }
            }}
          />
        </div>
      </div>
    );
  }
  getInputField() {
    return (
      <div
        className="row parent-width justify-content-between align-items-start position-relative mt-m"
        // style={{ minHeight: "82px", maxHeight: "150px" }}
      >
        {this.getInputSection()}
        {this.getPermissionSection()}
      </div>
    );
  }
  getInputSection() {
    return (
      <div className="column parent-width">
        <DKInput
          title="Team Name"
          autoFocus
          type={INPUT_TYPE.TEXT}
          value={this.state.name}
          direction={INPUT_VIEW_DIRECTION.VERTICAL}
          required
          canValidate={this.state.canValidate}
          onChange={(value) => {
            this.setState({ name: value });
          }}
        />
      </div>
    );
  }
  getPermissionSection() {
    return (
      <div className="column ml-s mt-xl">
        <div
          className="row border-m border-radius-s cursor-hand position-relative p-h-s p-v-s justify-content-center"
          style={{ minWidth: "105px" }}
        >
          <DKLabel text={this.state.permission.title} className="text-gray" />
          <DKIcon
            src={DKIcons.ic_arrow_down2}
            className=" ic-xs-2 ml-xs"
            style={{ opacity: 0.4 }}
          />
          <div
            className="parent-width parent-height position-absolute"
            style={{ top: 0, left: 0 }}
            onClick={() => this.setVisibilityOfPermissionPicker(true)}
          />
          {this.state.needPermissionPicker && (
            <DKListPicker
              data={Object.keys(PERMISSIONS).map(
                (key) => PERMISSIONS[key].title
              )}
              className="position-absolute border-radius-s shadow-s-2 border-s"
              style={{ left: 0, botton: 0, zIndex: 2 }}
              width={100}
              onClose={() => this.setVisibilityOfPermissionPicker(false)}
              onSelect={(index) => {
                this.setVisibilityOfPermissionPicker(false);
                this.onPermissionSelect(
                  PERMISSIONS[Object.keys(PERMISSIONS)[index]]
                );
              }}
            />
          )}
        </div>
      </div>
    );
  }
  getUsersSection() {
    return (
      <div
        className="scroll-y-only-web hide-scroll-bar parent-width border-s parent-width border-radius-s border-box mt-xl flex-wrap justify-content-start"
        style={{ overflowX: "hidden" }}
      >
        {this.props.users.length > 0 && this.getAllUsers()}
      </div>
    );
  }
  getAllUsers() {
    let users = [];
    this.props.users.forEach((user) => {
      users.push(this.getUserRow(user));
    });
    return users;
  }
  getUserRow(user) {
    const userId = this.state.userIds.find((id) => id == user.iamUserId);
    return (
      <div className="row justify-content-between listPickerBG p-h-r p-v-m">
        <div className="row width-auto">
          <DKContactIcon
            title="Rohan"//{getFullName(user)}
            className="border-m bg-gray1"
          />
          <div className="column ml-m">
            {user.status !== INVITE_USER_STATUS.SENT && (
              <DKLabel
                text="rohan"//{userId ? `${getFullName(user)} ✓` : getFullName(user)}
                className="fw-m mb-xs"
              />
            )}
            <DKLabel
              text={user.email}
              className={
                user.status !== INVITE_USER_STATUS.SENT ? " text-gray" : ""
              }
            />
          </div>
        </div>
        {user.status === INVITE_USER_STATUS.SENT && (
          <DKLabel text="Pending invitation" className="text-red" />
        )}
        {user.status !== INVITE_USER_STATUS.SENT && (
          <div className="column">
            {this.state.userIds.some((id) => id == user.iamUserId) ? (
              <div
                className="row width-auto justify-content-between bg-white p-h-s p-v-xs  border-radius-s cursor-hand position-relative"
                onClick={() => {
                  this.removeUser(user);
                }}
              >
                <DKLabel text="Remove" className="text-gray" />
              </div>
            ) : (
              <div
                className="row width-auto justify-content-between bg-white p-h-s p-v-xs  border-radius-s cursor-hand position-relative"
                onClick={() => {
                  this.addUser(user);
                }}
              >
                <DKLabel text="+ Add" className="text-gray" />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
  getInviteUserSection() {
    return (
      <div className="mt-m parent-width">
        <InviteUser
          inviteUserTapped={(data) => this.inviteUser(data)}
          hidePermission={true}
        />
      </div>
    );
  }
  inviteUser(data) {
    showAlert(
      "Invitation sent!",
      "Email has been sent successfully. Click on the email to accept the invitation."
    );
  }
  setVisibilityOfPermissionPicker = (visible) => {
    this.setState({ needPermissionPicker: visible });
  };
  onPermissionSelect = (value) => {
    this.setState({ permission: value });
  };
  validateName() {
    let valid = true;
    if (
      this.state.name === null ||
      this.state.name === undefined ||
      this.state.name === "" ||
      (typeof this.state.name === "string" && this.state.name.trim() === "")
    ) {
      valid = false;
    }
    return valid;
  }
  addUser(user) {
    let ids = [...this.state.userIds];
    ids.push(user.iamUserId.toString());
    this.setState({ userIds: ids });
  }
  removeUser(user) {
    let ids = [...this.state.userIds].filter(
      (userId) => userId != user.iamUserId
    );
    this.setState({ userIds: ids });
  }
  onSubmit() {
    let dataToSend = {};
    if (this.state.userIds && this.state.userIds.length === 0) {
      showAlert(
        "No user added!",
        "Add at-least one user to this team to proceed. Team can't be created without a user."
      );
      return;
    }
    dataToSend = {
      name: this.state.name,
      userIds: this.state.userIds,
    };
    // (this.props.selectedTeam && this.props.selectedTeam._id
    //   ? Team.updateTeam({
    //       ...dataToSend,
    //       id: this.props.selectedTeam._id,
    //     })
    //   : Team.addTeam(dataToSend)
    // ).then((response: any) => {
    //   if (response && response.id) {
    //     this.updateTeamPermission(response.id);
    //   } else {
    //     // store.dispatch(fetchTeams());
    //     this.removePopUp();
    //   }
    // });
  }
  removePopUp = () => {
    this.props.onClose?.();
  };
  updateTeamPermission = (teamId) => {
    let permissionPayload: any = {
      teams: [
        {
          id: teamId,
          accessLevel: this.state.permission.permissions_level,
        },
      ],
    };
    this.props.onTeamCreate(permissionPayload);
    // store.dispatch(fetchTeams());
    this.removePopUp();
  };
}
const mapStateToProps = (state) => ({
  users: state.tenant.users,
});
const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(AddTeamPopup);
